module.exports = __webpack_public_path__ + "img/loding_pro.c8fc7f01.png";